import React, {useState} from "react";
import 'react-calendar/dist/Calendar.css';
import ProfileInfo from "./ProfileInfo";
import ProfileEdit from "./ProfileEdit";

function Profile() {

	const [showInfo,setShowInfo] = useState(true)

	const handleEdit = (data) => {
		setShowInfo(!data);
		console.log(showInfo)
	};

	const handleInfo = (data) => {
		setShowInfo(!data);
		console.log(showInfo)
	};


	if (showInfo){
		return <ProfileInfo edit={handleInfo}/>
	}else{
		return <ProfileEdit edit={handleEdit}/>
	}
}

export default Profile;
